import { render, staticRenderFns } from "./TermoTipo.vue?vue&type=template&id=96c3b31a&scoped=true&"
import script from "./TermoTipo.vue?vue&type=script&lang=js&"
export * from "./TermoTipo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96c3b31a",
  null
  
)

export default component.exports